var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 238 216",
    style: {
      enableBackground: "new 0 0 238 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.wait0{fill:#39003C;}\n\t.wait1{fill:#FFFFFF;}\n\t.wait2{fill:#EFB484;}\n\t.wait3{fill:#BB4E4D;}\n\t.wait4{fill:#F37E72;}\n\t.wait5{fill:#FFC999;}\n\t.wait6{fill:#FDCBC7;}\n\t.wait7{fill:#F0ACAE;}\n\t.wait8{fill:#3E0040;}\n\t.wait9{fill:none;}\n\t.wait10{fill:#D86C69;}\n\t.wait11{fill:#FFF3F3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000143601326960842558330000009976532541184134046_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000084532449333784459120000016989126683040453810_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_17"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "wait0",
    cx: 119.3,
    cy: 110.9,
    r: 90
  }), /*#__PURE__*/React.createElement("path", {
    className: "wait1",
    d: "M119.3,204.9c-51.8,0-94-42.2-94-94s42.2-94,94-94s94,42.2,94,94S171.2,204.9,119.3,204.9z M119.3,24.9 c-47.4,0-86,38.6-86,86s38.6,86,86,86s86-38.6,86-86S166.8,24.9,119.3,24.9z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_451"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1809",
    className: "wait2",
    d: "M152.9,60.5l-1.7-13.4l-6.3-6.2c0,0-6.6,5.8-6.6,6.2v3.6L152.9,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1810",
    className: "wait3",
    d: "M169.7,65.5l-6,7.5l-5.5-6.6L169.7,65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1811",
    className: "wait4",
    d: "M144.9,42.5L150,48l2.1,10.9l8.2,8.6l9.3-2l1.7-7l-1.5-3.5l-6.6-1.5l-2.3,3.1l-0.6,3.8 l-3.5-2.8L153.8,46l-3.7-5.9L144.9,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1812",
    className: "wait2",
    d: "M121.2,37.7l-10.4-3.5L96.2,46.9l-2.4,5l-1.3,4.6l25.5-9L121.2,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1813",
    className: "wait3",
    d: "M78.3,49.5l-2.2,12.9l1.8,5.1l15.8-14l0.5-1.4L78.3,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1814",
    className: "wait4",
    d: "M119,39.1l-6-1.9l-10,4.9l-8.8,10.1L85,57l-5.2-0.8l-1.5-6.7l6-4.4l5.1,1.4l-2.2,4.7l3.4-1 l15.6-18l6.1-1.9l6.6,1.9L119,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1815",
    className: "wait5",
    d: "M154.8,34.3l-0.1-0.5l-0.2-1.6l-1.7,0.1h-0.2c0.1,0.5,0.3,0.9,0.6,1.3 C153.7,33.9,154.2,34.2,154.8,34.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1816",
    className: "wait5",
    d: "M154.5,35.2l-0.6,3.2L138.6,47l-0.5,2.3l-0.2,1.5l-1.5-1.1l-4.9,3.6l-6.3,6.2l0.2,6.8 l-5.1-7.8l-0.1-6.2l-3.3-5.8l-2,1.1l0.5-3.2h0l4.7-27.6l5.7,11.9l8.1,0.2l6-10.7v14.7l10.3-0.5l1.5-0.1c0.1,0.7,0.4,1.3,0.9,1.8 C153,34.7,153.7,35.1,154.5,35.2L154.5,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1817",
    className: "wait3",
    d: "M58.7,99.5l-1.8,19.2l4.6,22.7l22.2,18.8l37.7,13.2l37.5-9.7l15.7-24.7l6.3-28.6L58.7,99.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1818",
    className: "wait4",
    d: "M121.6,45.1l-26.3,7L71.2,73.4L58.7,99.5l5.3,27.1l20.6,19.6l38.9,14l33.6-8.8l17.1-20.1 l7-21.1l-3.8-23.8l-23.1-26.1l-18.8-13.3L121.6,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1819",
    className: "wait6",
    d: "M176.4,109.7l-6.5,19.4l-15.7,18.5l-31,8.1l-35.9-13l-19-18.1l-4.9-25L75,75.6L97.2,56 l24.3-6.5l12.7,1.8l17.4,12.3l9.3,10.6h0l11.9,13.5L176.4,109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1820",
    className: "wait7",
    d: "M176.4,109.7l-6.5,19.4l-15.7,18.5l-31,8.1l-35.9-13l44.2-0.5l24.1-20.4l10.2-28.2 L161,74.2h0l11.9,13.5L176.4,109.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    x: 66.6,
    y: 98.8,
    className: "wait8",
    width: 5.3,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    x: 167.5,
    y: 104.8,
    transform: "matrix(0.2078 -0.9782 0.9782 0.2078 28.081 249.6402)",
    className: "wait8",
    width: 1.4,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    x: 120.8,
    y: 149,
    transform: "matrix(1.214718e-02 -0.9999 0.9999 1.214718e-02 -27.7477 271.3835)",
    className: "wait8",
    width: 5.3,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    x: 123.3,
    y: 55.5,
    transform: "matrix(1.214718e-02 -0.9999 0.9999 1.214718e-02 68.1802 181.4329)",
    className: "wait8",
    width: 5.3,
    height: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1821",
    className: "wait0",
    d: "M99.3,80c0,0,7.4-2.1,11.9-0.8c2.9,0.8,1,4.6-1.1,4.7s-4.2-1.9-3.8-3.5 C102.2,80.2,97.9,80.3,99.3,80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1822",
    className: "wait0",
    d: "M132,80.4c0,0,5.9-1.9,9.5-0.6c2.4,0.8,0.9,4.3-0.9,4.3c-1.8,0-3.1-1.5-3.1-3.3 c0,0,0,0,0,0C134.4,80.7,130.9,80.7,132,80.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1823",
    className: "wait0",
    d: "M130.2,72.4c0,0,9-2.9,13.7-1.3c4.8,1.6,6.1,4.1,6.1,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1824",
    className: "wait0",
    d: "M93,72.9c0,0,8.4-4.3,13.3-3.5s6.7,3.1,6.7,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1825",
    className: "wait1",
    d: "M109,114c0,0,5.3-13.5,16-10.7s9,14.6,9,14.6L109,114z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_1",
    className: "wait9",
    x1: 86.6,
    y1: 109.2,
    x2: 122,
    y2: 93
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    x: 84.9,
    y: 100.1,
    transform: "matrix(0.9093 -0.4161 0.4161 0.9093 -32.6154 52.5703)",
    className: "wait10",
    width: 38.9,
    height: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_2",
    className: "wait9",
    x1: 126.6,
    y1: 94.1,
    x2: 160.4,
    y2: 128.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    x: 142.5,
    y: 87.2,
    transform: "matrix(0.717 -0.697 0.697 0.717 -37.0615 131.5719)",
    className: "wait10",
    width: 2,
    height: 48.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1826",
    className: "wait11",
    d: "M124.8,87.2l-4.3,0.6l-1.5,4.6l3.1,2.9h5.7l1.4-4.1l-2-3.5L124.8,87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1827",
    className: "wait3",
    d: "M88.7,99.6l-3.2,7.9l-6.6,5.4l9.3-1.8h8.9l-9.6-2.3L88.7,99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1828",
    className: "wait3",
    d: "M149.9,128.6l8.5,0.8l7.1,4.7l-4.5-8.3l-2.6-8.5l0.7,9.9L149.9,128.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWait);
export default __webpack_public_path__ + "static/media/wait.24fa288c3d777893dbecfc1f9db58afe.svg";
export { ForwardRef as ReactComponent };